<template>
  <div>
    <el-row :gutter="24" v-if="Kisi_id">
      <el-col :span="19">
        <div v-if="lo" style="color: #fff">-</div>
        <div class="tBorcBilgi" v-if="!lo">
          <div class="BorcKutu">
            <mWidget
              :data="{isim: 'Güncel Dönem', sayi: AltToplam.GuncelText+' TL', icon: 'el-icon-info', renk: 'ins1 m-widget-mini'}"></mWidget>
          </div>
          <div class="BorcKutu" v-if="AltToplam.Odenecek.Toplam">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                <div class="tBilgi">
                  <span><small>Zam</small> {{ AltToplam.OdenecekText.Zam }} TL</span><br>
                  <span><small>Tutar</small> {{ AltToplam.OdenecekText.Toplam }} TL</span>
                </div>
              </div>
              <mWidget
                :data="{isim: 'Ödenecek', sayi: AltToplam.OdenecekText.Odenecek+' TL', icon: 'el-icon-success', renk: 'ins2 m-widget-mini'}"></mWidget>
            </el-tooltip>
          </div>
          <div class="BorcKutu" v-if="AltToplam.Gecikmis.Toplam">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                <div class="tBilgi">
                  <span><small>Zam</small> {{ AltToplam.GecikmisText.Zam }} TL</span><br>
                  <span><small>Tutar</small> {{ AltToplam.GecikmisText.Toplam }} TL</span>
                </div>
              </div>
              <mWidget
                :data="{isim: 'Gecikmiş', sayi: AltToplam.GecikmisText.Odenecek+' TL', icon: 'el-icon-warning', renk: 'ins3 m-widget-mini'}"></mWidget>
            </el-tooltip>
          </div>
          <div class="BorcKutu" v-if="AltToplam.Icra.Toplam && !Veznedar">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                <div class="tBilgi">
                  <span><small>Zam</small> {{ AltToplam.IcraText.Zam }} TL</span><br>
                  <span><small>Tutar</small> {{ AltToplam.IcraText.Toplam }} TL</span>
                </div>
              </div>
              <mWidget
                :data="{isim: 'İcraya Müsait', sayi: AltToplam.IcraText.Odenecek+' TL', icon: 'el-icon-error', renk: 'ins4 m-widget-mini'}"></mWidget>
            </el-tooltip>
          </div>
          <div class="BorcKutu" v-if="Icra && !Veznedar">
            <el-popover
              placement="bottom"
              width="600"
              trigger="click">
              <table class="table-sm table">
                <thead>
                <tr>
                  <th>Avukat Ünvan</th>
                  <th>Avukat Telefon</th>
                  <th>Avukat Adres</th>
                  <th>Dosya No</th>
                  <th>İcra Tarihi</th>
                  <th class="text-right">Ödenecek Tutar</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="i in Icra">
                  <td>{{ i.Bilgi.Unvan }}</td>
                  <td>{{ i.Bilgi.Telefon }}</td>
                  <td>{{ i.Bilgi.Adres }}</td>
                  <td>{{ i.Bilgi.dNo }}</td>
                  <td>{{ i.Bilgi.iTarihText }}</td>
                  <td class="text-right">{{ i.Bilgi.AltToplam }}</td>
                </tr>
                </tbody>

              </table>
              <el-button size="mini" type="info" @click="$router.push('/icra/dosya/'+Kisi_id)"
                         class="btn-block">
                Detaylı İcra Ekranı
              </el-button>

              <mWidget slot="reference"
                       :data="{isim: 'Detay İçin Tıklayınız', sayi: Icra.length+' Dosya', icon: 'el-icon-message-solid', renk: 'ins7 m-widget-mini'}"></mWidget>
            </el-popover>
          </div>
        </div>

        <el-table
          v-if="Liste"
          ref="multipleTable"
          class="table-xs"
          :data="Liste"
          @selection-change="handleSelectionChange"
          width="100%"
          :height="Height"
          show-summary
          :summary-method="TableFooter"
          :row-class-name="TableClass"
        >
          <el-table-column
            type="selection"
            width="50">
          </el-table-column>

          <el-table-column
            prop="tTarihi"
            label="T.Tarihi"
            width="100">
          </el-table-column>
          <el-table-column
            prop="sTarihi"
            label="S.Ö.Tarihi"
            width="100">
          </el-table-column>
          <el-table-column
            prop="Kategori"
            label="Kategori"
            width="100">
          </el-table-column>
          <el-table-column
            prop="Aciklama"
            label="Açıklama"
          >
          </el-table-column>
          <el-table-column
            prop="Zam"
            label="Zam Bilgi"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="TutarText"
            label="Tutar"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            prop="ZamTutarText"
            label="Zam"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            prop="OdenecekText"
            label="Ödenecek"
            width="90"
            align="right">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="5">

        <div class="SecimKutu mb-3">
          <el-row :gutter="24">
            <div v-if="BankaEkstre" class="VezneBankaOlayi">
              <img :src="'https://pos.mudu.pro/oi/banka/'+BankaEkstre.Banka+'.png'" width="100">
              <span><sup>Dekont Tutarı</sup> <b>{{ BankaEkstre.TutarText }}<sup>TL</sup></b></span>
            </div>
            <el-col :span="24" v-if="DuzenleYetki>0">
              <span style="font-size: 12px">Ödeme Tarihi

                 <el-popover
                   placement="right"
                   width="200"
                   trigger="click">
                    <div class="HesaplamaKutu">
                      <span style="font-size: 12px">Hesaplama Tarihi</span>
                      <el-date-picker
                        v-model="HesaplamaTarihi"
                        @change="fHesaplamaTarihi"
                        type="date"
                        size="mini"
                        placeholder="Hesaplama Tarihi"
                        format="dd.MM.yyyy"
                        value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>
                    <a class="HesaplamaTarihi" slot="reference">
                      <i class="feather-refresh-ccw"></i>
                    </a>
                  </el-popover>


              </span>

              <el-date-picker
                v-model="Tarih"
                @change="OdemeTarihHesapla"
                type="date"
                size="mini"
                placeholder="Ödeme Tarihi"
                format="dd.MM.yyyy"
                value-format="yyyy-MM-dd">
              </el-date-picker>

              <hr>
            </el-col>
            <el-col :span="6">
              <div class="Secilen text-info">
                <small>Seçilen</small>
                <p>{{ Secilen.length }}</p>
              </div>
            </el-col>
            <el-col :span="18">
              <div class="BorcBilgi">
                <div class="Zam text-danger">
                  <p><small>
                    <el-tooltip class="item" effect="dark" content="Zam temizle" placement="top">
                      <a @click="ZamSil" href="#" class="text-info" v-if="DuzenleYetki>0"><i
                        class="el-icon-remove"></i></a>
                    </el-tooltip>
                    Zam</small> {{ st.ToplamZam }}
                  </p>
                </div>
                <div class="Anapara text-success">
                  <p><small>Anapara</small> {{ st.ToplamTutar }}</p>
                </div>
                <div class="Odenecek text-primary">
                  <small>Ödenecek Tutar</small>
                  <p>{{ st.ToplamOdenecek }}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="KomisyonOlayi" v-if="OdemeOlay.Komisyon>0">
                <small class="text-danger">Komisyon <b>{{ OdemeOlay.Komisyon }} TL</b></small>
                <small>{{ OdemeOlay.KomisyonText }}</small>
              </div>
              <div class="KomisyonOlayi" v-if="OdemeOlay.tmKomisyon">
                <small class="text-danger">Hizmet Bedeli <br><b>{{ OdemeOlay.tmKomisyon }} TL</b></small>
              </div>
              <hr>
              <el-input
                placeholder="Ödenecek Tutar"
                v-model="st.ToplamOdenecek">
              </el-input>
            </el-col>
            <el-col :span="24" v-if="st.ToplamOdenecek>0">
              <el-cascader
                v-if="!this.Veznedar"
                collapse-tags
                @change="KomisyonHesapla"
                placeholder="Kasa Seçiniz"
                :props="{ multiple: false}"
                :options="Kasalar"
                v-model="OdemeOlay.Kasa_id"
                filterable></el-cascader>
              <el-input
                placeholder="Açıklama"
                type="textarea"
                v-model="OdemeOlay.Aciklama">
              </el-input>
              <el-button class="btn-block" @click="OdemeAl" size="small"
                         type="success"><b v-if="OdemeOlay.Odenecek">{{ OdemeOlay.Odenecek }} TL</b> Ödeme
                Al
              </el-button>
              <div v-if="Secilen.length==0 && !this.Veznedar">
                <hr class="m-0">
                <el-button class="btn-block btn-xs" @click="EmanetOdemeAl" size="mini"
                           type="info"><b v-if="OdemeOlay.Odenecek">{{ OdemeOlay.Odenecek }} TL</b> Emanet
                  Ödeme Al
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>

        <div v-if="!Veznedar" class="BlokSabit scrollkaydir"
             :style="Secilen.length>0?'height:'+(Height - 360)+'px':'height:'+(Height - 230)+'px'">
          <div class="DigerBorclular BilgiKutu" v-if="DigerBorclu">
            <h1>Diğer Borçlular</h1>
            <router-link tag="div" :to="'/vezne/tahsilat/'+b.id" v-for="b in DigerBorclu">
              <span class="AdSoyad">{{ b.AdSoyad }}</span>
              <span class="Borc">{{ b.Borc }} <sup>TL</sup></span>
            </router-link>
          </div>
          <div class="BlokSabitKutu">
            <BilgiKutu :data="Borclu" v-if="Borclu"></BilgiKutu>
            <Notlar :data="Notlar" v-if="Notlar"></Notlar>
            <BilgiKutu :data="Sahip" v-if="Sahip"></BilgiKutu>
          </div>
        </div>
      </el-col>
    </el-row>
    <Yukleniyor :data="lo"></Yukleniyor>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="ModalKapat"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
    <el-dialog
      append-to-body
      title="Tahsilatı Onaylayınız"
      :visible.sync="OdemeOnayModal"
      width="30%">
      <div v-html="ModalAciklama"></div>
      <div v-if="EmanetKategoriSecim">
        <hr>
        <span> Emanete alınan bakiye için Kategori seçebilirsiniz.</span>
        <el-cascader
          collapse-tags
          :props="{ multiple: true }"
          :options="Kategoriler"
          v-model="OdemeOlay.EmanetKategori"
          filterable></el-cascader>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="OdemeOnayModal = false" size="small">Vazgeç</el-button>
        <el-button type="primary" @click="MakbuzUret" :disabled="lo" size="small">Tahsil et ve Makbuz üret
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>

import BilgiKutu from "../Genel/BilgiKutu";
import MakbuzDetay from "./MakbuzDetay";
import mWidget from "../Genel/mWidget";
import Yukleniyor from "../../Doc/Yukleniyor";
import Notlar from "../Genel/Notlar";

export default {
  props: ['Kisi_id', 'BankaEkstre', 'Veznedar'],
  components: {Notlar, Yukleniyor, mWidget, MakbuzDetay, BilgiKutu},
  data() {
    return {
      Height: window.innerHeight - 195,
      EmanetKategoriSecim: false,
      OdemeOnayModal: false,
      Kategoriler: null,
      ModalAciklama: null,
      DuzenleYetki: null,
      MakbuzDetayModal: false,
      Yenile: false,
      SayfaAdi: 'Tahsilat Ekranı',
      Liste: [],
      Secilen: null,
      Kaydet: false,
      mNo: null,
      lo: false,
      st: {
        ToplamTutar: 0,
        ToplamZam: 0,
        ToplamOdenecek: 0,
        Guncel: 0,
        Gecikmis: {Toplam: 0, Zam: 0, AltToplam: 0},
        Icra: {Toplam: 0, Zam: 0, AltToplam: 0},
        Odenecek: {Toplam: 0, Zam: 0, AltToplam: 0},
      },
      Borclu: null,
      Icra: null,
      Bilgi: null,
      Sahip: null,
      Bina_id: null,
      BinaBilgi: null,
      TahakkukAdet: null,
      Kasalar: null,
      AltToplam: {
        ToplamTutar: 0,
        ToplamZam: 0,
        ToplamOdenecek: 0,
        Guncel: 0,
        GuncelText: 0,
        Gecikmis: {Toplam: 0, Zam: 0, AltToplam: 0},
        Icra: {Toplam: 0, Zam: 0, AltToplam: 0},
        Odenecek: {Toplam: 0, Zam: 0, AltToplam: 0},
      },
      Tarih: null,
      HesaplamaTarihi: null,
      OdemeOlay: {
        Secilen: [],
        EmanetKategori: null,
        Tarih: null,
        HesaplamaTarihi: null,
        Kasa_id: null,
        Kisi_id: null,
        Kasa: null,
        KasaAdi: null,
        Aciklama: null,
        Komisyon: 0,
        KomisyonText: null,
        Emanet: false,
        Banka_Dokum_id: null,
        st: {},
        Odenecek: null
      },
      ZamBilgi: null,
      bKomisyon: null,
      mWidget: null,
      Notlar: null
    }
  },
  methods: {
    OdemeTarihHesapla() {
      this.HesaplamaTarihi = this.Tarih;
      this.fHesaplamaTarihi();
    },
    fHesaplamaTarihi() {
      this.TarihHesapla(this.HesaplamaTarihi);
    },
    KomisyonHesapla() {

      if (this.OdemeOlay.Kasa_id) {

        var KasaOlay = this.OdemeOlay.Kasa_id[1];
        if (KasaOlay) {
          var UstKasa = this.OdemeOlay.Kasa_id[0];
          SeciliKasa = this.Kasalar.filter(data => !UstKasa || data.id.toLowerCase().includes(UstKasa.toLowerCase()))[0].children.filter(data => !KasaOlay || data.id.toLowerCase().includes(KasaOlay.toLowerCase()))[0];
        }
        if (!KasaOlay) {
          KasaOlay = this.OdemeOlay.Kasa_id[0];
          var SeciliKasa = this.Kasalar.filter(data => !KasaOlay || data.id.toLowerCase().includes(KasaOlay.toLowerCase()))[0];
        }
        if (SeciliKasa.fPos || SeciliKasa.sPos) {
          this.OdemeOlay.Komisyon = Number(this.st.ToplamOdenecek * this.bKomisyon / 100).toFixed(2);
          this.OdemeOlay.KomisyonText = "Kasada binaya %" + this.bKomisyon + " komisyon uygulanmaktadır.";
        }
        if (!SeciliKasa.fPos && !SeciliKasa.sPos) {
          this.OdemeOlay.Komisyon = 0;
          this.OdemeOlay.KomisyonText = null;
        }
        this.OdemeOlay.Kasa = KasaOlay;
        this.OdemeOlay.KasaAdi = SeciliKasa.Adi;
        this.OdemeOlay.Odenecek = (Number(this.st.ToplamOdenecek) + Number(this.OdemeOlay.Komisyon)).toFixed(2);

        if (this.Veznedar) this.VeznedarKomisyon();
      }
    },
    VeznedarKomisyon() {
      if (this.st.ToplamOdenecek > Number(this.Veznedar.lKasa)) {
        this.st.ToplamOdenecek = this.Veznedar.lKasa;
        this.$message.error("Kalan bakiyeniz " + this.st.ToplamOdenecek + " " + this.Veznedar.lKasa + "TL dir.");
      }
      this.OdemeOlay.tmKomisyon = Number(this.st.ToplamOdenecek * this.Veznedar.Komisyon / 100).toFixed(2);
      if (this.OdemeOlay.tmKomisyon < this.Veznedar.Tutar) this.OdemeOlay.tmKomisyon = this.Veznedar.Tutar;
    },
    TableClass({row}) {
      return row.Class
    },
    ModalKapat() {
      this.SayfaYukle();
      this.Yenile = true;
    },
    ZamSil() {
      this.st.ToplamZam = 0;
      this.st.ToplamOdenecek = this.st.ToplamTutar;
      this.ZamBilgi = 'Zam tahsil edilmeyecektir.'
    },
    TableFooter() {
      const sums = [];
      sums[6] = this.AltToplam.AltTutar;
      sums[7] = this.AltToplam.AltZam;
      sums[8] = this.AltToplam.AltToplam;
      return sums;
    },
    handleSelectionChange(val) {
      this.Secilen = val;
      this.st.ToplamTutar = this.Secilen.reduce((acc, item) => acc + Number(item.Tutar), 0).toFixed(2);
      this.st.ToplamZam = this.Secilen.reduce((acc, item) => acc + Number(item.ZamTutar), 0).toFixed(2);
      this.st.ToplamOdenecek = (Number(this.st.ToplamTutar) + Number(this.st.ToplamZam)).toFixed(2);
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    EmanetOdemeAl() {
      this.OdemeOlay.Emanet = true;
      this.OdemeIsle();
    },
    OdemeAl() {
      this.OdemeOlay.Emanet = false;
      this.OdemeIsle();
    },
    MakbuzUret() {
      this.lo = true;
      this.$store.dispatch("Post", {...this.OdemeOlay, path: 'vezne/makbuz'})
        .then(response => {
          if (response.Durum == "OK") {

            this.SayfaYukle();
            this.mNo = response.mNo;
            this.MakbuzDetayModal = true;
            this.Yenile = true;
            this.lo = false;

          } else {

            this.$message.error(response.Mesaj);
            this.hata = response.Hata;

          }
        })
    },
    OdemeIsle() {
      if (this.OdemeOlay.Kasa_id) {
        this.OdemeOlay.Kisi_id = this.Kisi_id;
        this.OdemeOlay.Bina_id = this.Bina_id;
        this.OdemeOlay.Secilen = this.Secilen;
        this.OdemeOlay.Tarih = this.Tarih;
        this.OdemeOlay.HesaplamaTarihi = this.HesaplamaTarihi;
        this.OdemeOlay.st = this.st;
        var KomisyonText = "";
        var EmanetText = "";
        var EmanetPara = 0;

        if (this.st.ToplamTutar) EmanetPara = Number(this.st.ToplamOdenecek) - (Number(this.st.ToplamTutar) + Number(this.st.ToplamZam));
        if (EmanetPara == 0) EmanetPara = Number(this.st.ToplamOdenecek) - Number(this.AltToplam.AltToplam);
        if (this.OdemeOlay.Emanet) EmanetPara = Number(this.st.ToplamOdenecek);
        this.EmanetKategoriSecim = false;
        if (EmanetPara.toFixed(2) > 0) {
          EmanetText = "<br><b class='text-success bold'>" + EmanetPara.toFixed(2) + " TL Emanet ödeme olarak işlenecektir.</b>";
          this.EmanetKategoriSecim = true;
        }
        if (this.OdemeOlay.Komisyon > 0) KomisyonText = "(<b>" + this.OdemeOlay.Komisyon + " TL</b> komisyon dahil)";
        this.ModalAciklama = "<b>" + this.OdemeOlay.KasaAdi + "</b> kasasına " + KomisyonText + " <b>" + this.OdemeOlay.Odenecek + " TL</b> giriş olacaktır.<br><small class='text-danger'>Ödemeyi doğru aldığınızdan emin olunuz.</small>" + EmanetText;
        this.OdemeOnayModal = true;


      } else {
        this.$message.error("Lütfen Kasa Seçiniz.");
      }

    },
    Sifirla() {

      this.Icra = null;
      this.DigerBorclu = null;
      this.OdemeOnayModal = false;
      this.TahakkukAdet = null;
      this.Liste = null;
      this.MakbuzDetayModal = false;
      this.Secilen = [];
      this.Kasalar = null;
      this.Tutar = null;
      this.Borclu = null;
      this.Notlar = null;
      this.Sahip = null;
      this.Yenile = false;
      this.Komisyon = null;
      this.OdemeOlay = {
        Secilen: [],
        Tarih: null,
        Kasa_id: null,
        Kasa: null,
        Aciklama: null,
        Komisyon: 0,
        Emanet: false,
        Banka_Dokum_id: null,
        KomisyonText: null,
        st: {},
        Odenecek: null
      };
      this.st = {
        ToplamTutar: 0,
        ToplamZam: 0,
        ToplamOdenecek: 0
      };
      if (this.Veznedar) {
        this.OdemeOlay.Kasa_id = this.Veznedar.Kasa_id;
        this.Height = '66vh'
        //this.KomisyonHesapla();
      }
    },
    TarihHesapla(Tarih) {
      this.SayfaYukle(Tarih ? Tarih : this.Tarih);
    },
    BankaOlayi() {
      //console.log(this.st.ToplamOdenecek, this.BankaEkstre.Kalan);
      if (this.BankaEkstre) {
        if (Number(this.st.ToplamOdenecek) > Number(this.BankaEkstre.Kalan)) {
          this.$message.error("En Fazla dekont kalan bedeli olan " + this.BankaEkstre.KalanText + "TL tahsil edebilirsiniz.");
          this.st.ToplamOdenecek = this.BankaEkstre.Kalan;
        }
      }
    },
    SayfaYukle(Tarih) {

      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/kasa/' + this.Bina_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Kasalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

      this.Sifirla();
      //if (Tarih) this.Tarih = Tarih;
      this.$store.dispatch("Get", {path: 'vezne/kisi/' + this.Kisi_id + '/' + Tarih})
        .then(response => {
          if (response.Durum === 'OK') {
            this.lo = false;
            this.Liste = response.Tahakkuk;
            this.AltToplam = response.AltToplam;
            this.DigerBorclu = response.DigerBorclu;
            if (this.Liste) this.TahakkukAdet = this.Liste.length;
            this.SayfaAdi = response.Borclu.AdSoyad;
            this.$emit('SayfaAdi', this.SayfaAdi);
            this.Bina_id = response.Borclu.Bina_id;
            this.Icra = response.Icra;
            this.bKomisyon = response.Komisyon;
            this.Notlar = {
              Modul: 'Kisi',
              Modul_id: this.Kisi_id
            };
            this.Borclu = {
              Baslik: 'Borçlu Bilgi',
              Detay: [
                {Baslik: 'Ad Soyad', Bilgi: response.Borclu.AdSoyad, Ikon: 'flaticon-background'},
                {Baslik: 'Bina Adı', Bilgi: response.Borclu.BinaAdi, Ikon: 'flaticon-background'},
                {
                  Baslik: 'Mesken Bilgi',
                  Bilgi: response.Borclu.Kat + '.Kat ' + response.Borclu.kNo + ' Numara - ' + response.Borclu.m2 + 'm<sup>2</sup>',
                  Ikon: 'flaticon-background'
                },
                {Baslik: 'Telefon', Bilgi: response.Borclu.Telefon, Ikon: 'flaticon-background'},
                {Baslik: 'TC Kimlik', Bilgi: response.Borclu.vNo, Ikon: 'flaticon-background'},
                {
                  Baslik: 'Giriş Tarihi',
                  Bilgi: response.Borclu.gTarihi,
                  Ikon: 'flaticon-background'
                },
                {
                  Baslik: 'Çıkış Tarihi',
                  Bilgi: response.Borclu.cTarihi,
                  Ikon: 'flaticon-background'
                },
              ]
            };
            if (response.Sahip) {
              this.Sahip = {
                Baslik: 'Sahip Bilgi',
                Detay: [
                  {
                    Baslik: 'Ad Soyad',
                    Bilgi: response.Sahip.AdSoyad,
                    Ikon: 'flaticon-background'
                  },
                  {Baslik: 'Telefon', Bilgi: response.Sahip.Telefon, Ikon: 'flaticon-background'},
                  {Baslik: 'TC Kimlik', Bilgi: response.Sahip.vNo, Ikon: 'flaticon-background'},
                  {
                    Baslik: 'Giriş Tarihi',
                    Bilgi: response.Sahip.gTarihi,
                    Ikon: 'flaticon-background'
                  },
                  {
                    Baslik: 'Çıkış Tarihi',
                    Bilgi: response.Sahip.cTarihi,
                    Ikon: 'flaticon-background'
                  },
                ]
              }
            }


          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    }
  },
  created() {

    this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
      .then(response => {
        if (response.Durum === 'OK') {
          this.Kategoriler = response.Liste
        } else {
          this.$message.error(response.Mesaj);
          this.hata = response.Hata;
        }
      });

    if (this.$store.getters.BinaBilgi) {
      this.BinaBilgi = this.$store.getters.BinaBilgi;
      this.Bina_id = this.BinaBilgi.id;
    }

    this.DuzenleYetki = this.$store.getters.Yetki.VezneTarih;


    this.SayfaYukle();
    if (this.BankaEkstre) {
      this.st.ToplamOdenecek = this.BankaEkstre.Kalan;
      this.OdemeOlay.Aciklama = this.BankaEkstre.Aciklama;
      this.Tarih = this.BankaEkstre.oTarihi;
      this.OdemeOlay.Banka_Dokum_id = this.BankaEkstre.id;
    }
    if (!this.Tarih) this.Tarih = new Date();
    this.HesaplamaTarihi = new Date();
    //this.TarihHesapla(this.Tarih);

  },
  computed: {
    KisiSecim() {
      return this.Kisi_id
    },
    YenileTakip() {
      return this.Yenile
    },
    ToplamOdenecek() {
      return this.st.ToplamOdenecek
    },
  },
  watch: {
    KisiSecim() {
      this.SayfaYukle();
      //console.log(this.Form.Tutar);
    },
    YenileTakip() {
      this.$emit('Yenile', this.Yenile)
    },
    ToplamOdenecek() {
      if (this.st.ToplamOdenecek) {
        this.st.ToplamOdenecek = this.st.ToplamOdenecek.replace(",", ".");
        this.KomisyonHesapla();
        this.BankaOlayi();
      }
      //console.log(this.Form.Tutar);
    },

  }

}
</script>

<style scoped>
.VezneBankaOlayi {
  padding: 0 10px;
  border-bottom: 1px solid #dcdee5;
  margin-bottom: 10px;
}

.VezneBankaOlayi img {
}

.VezneBankaOlayi span {
  float: right;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pack/Vezne/VezneKisiTahsilat.vue